import React, { useState, useEffect } from "react";
import Layout from "../component/layout";
import LeaseBalancesReport from "./leaseBalancesReport";
import LevyBalancesReport from "./levyBalancesReport";
import TicketReport from "./ticket_report";
import MonthlySummaryStatement from "./monthlySummaryStatement"; 
import WHTReport from "./whtReport";
import LevyForecastTab from "./LevyForecastTab";

import { getItem } from '../../../utils/localStorage';
import { makeRequest2 } from '../../../utils/makeRequest';
import { 
    getLeaseBalancesURL, 
    getLevyBalancesURL, 
    getTicketReportsURL,
    getMonthlySummaryURL 
} from '../../../utils/urls';

const Reports = () => {

    const [activeTab, setActiveTab] = useState("lease-balances");

    const [levyBalances, setLevyBalances] = useState([]);
    const [leaseBalances, setLeaseBalances] = useState([]);
    const [ticketReports, setTicketReports] = useState([]);
    const [invoiceSummary, setInvoiceSummary] = useState([]);  

    const tabs = [
        { id: "lease-balances", name: "Lease Balances Report", component: LeaseBalancesReport },
        { id: "levy-balances", name: "Levy Balances Report", component: LevyBalancesReport },
        { id: "ticket-reports", name: "Ticket Report", component: TicketReport },
        { id: "monthly-summary", name: "Monthly Summary Statement", component: MonthlySummaryStatement },
        { id: "levy-forecast", name: "Levy Forecast", component: LevyForecastTab },
        { id: "wht-report", name: "WHT Report", component: WHTReport }
    ];

    const getLeaseBalances = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const response = await makeRequest2(`${getLeaseBalancesURL}/${facilityId}`, 'GET', {});
            if (response.success) setLeaseBalances(response.data);
            else throw new Error(response.error);
        } catch (err) { console.error(err.message); }
    };

    const getLevyBalances = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const response = await makeRequest2(`${getLevyBalancesURL}/${facilityId}`, 'GET', {});
            if (response.success) setLevyBalances(response.data);
            else throw new Error(response.error);
        } catch (err) { console.error(err.message); }
    };

    const getTicketReports = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const response = await makeRequest2(`${getTicketReportsURL}/${facilityId}`, 'GET', {});
            if (response.success) setTicketReports(response.data);
            else throw new Error(response.error);
        } catch (err) { console.error(err.message); }
    };

    const getMonthlySummary = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const response = await makeRequest2(`${getMonthlySummaryURL}/${facilityId}`, 'GET', {});
            if (response.success) setInvoiceSummary(response.data);
            else throw new Error(response.error);
        } catch (err) { console.error(err.message); }
    };

    useEffect(() => {
        getLeaseBalances();
        getLevyBalances();
        getTicketReports();
        getMonthlySummary();   
    }, []);

    const renderActiveTabComponent = () => {
        const activeTabData = tabs.find(tab => tab.id === activeTab);
        if (!activeTabData) return null;

        const Component = activeTabData.component;

        return (
            <Component
                leaseBalances={leaseBalances}
                levyBalances={levyBalances}
                ticketReports={ticketReports}
                invoiceSummary={invoiceSummary} 
                refreshData={{
                    getLeaseBalances,
                    getLevyBalances,
                    getTicketReports,
                    getMonthlySummary  
                }}
            />
        );
    };

    return (
        <Layout>
            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            <h5>Reports</h5>
                        </div>

                        <div className="card-body">

                            <ul className="nav nav-tabs mb-4" role="tablist">
                                {tabs.map((tab) => (
                                    <li className="nav-item" key={tab.id}>
                                        <button
                                            className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                                            onClick={() => setActiveTab(tab.id)}
                                            type="button"
                                        >
                                            {tab.name}
                                        </button>
                                    </li>
                                ))}
                            </ul>

                            <div className="tab-content">
                                {renderActiveTabComponent()}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Reports;
